var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4ElectricityRegulation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.65 36L36.77 53.9l5.1 5.1H29V47.31v-1l5 5L44.07 40H21.23l20.56-24 3 2.6L29.92 36h22.73zM12 12H4v4h12V4h-4v8zM4 65h8v8h4V61H4v4zm56 8h4v-8h8v-4H60v12zm4-61V4h-4v12h12v-4h-8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Electricity_regulation.eb2d26df.svg";
export { SvgA4ElectricityRegulation as ReactComponent };